const sharedSelectStyles = {
  control: (provided, state) => ({
    ...provided,
    minHeight: "32px",
    height: "40px",
    width: "220px",
    borderColor: state.isFocused ? "#3182CE" : "#3182CE",
    borderWidth: "2px",
    borderRadius: "8px",
    backgroundColor: "white",
    boxShadow: state.isFocused
      ? "0 0 0 3px rgba(66, 153, 225, 0.6)"
      : "0 4px 6px rgba(0, 0, 0, 0.1)",
    "&:hover": {
      borderColor: "#2B6CB0",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    },
    fontSize: "14px",
    padding: "0 8px",
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: "0 4px",
  }),
  input: (provided) => ({
    ...provided,
    margin: 0,
    padding: 0,
  }),
  menu: (provided) => ({
    ...provided,
    width: "220px",
    maxHeight: "200px",
    overflowY: "auto",
    borderRadius: "8px",
  }),
  option: (provided, state) => ({
    ...provided,
    fontSize: "14px",
    backgroundColor: state.isSelected
      ? "#3182CE"
      : state.isFocused
      ? "#E2E8F0"
      : "white",
    color: state.isSelected ? "white" : "#1A202C",
    "&:hover": {
      backgroundColor: "#E2E8F0",
    },
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "#1A202C",
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "#A0AEC0",
  }),
};

export default sharedSelectStyles;

